



























































































































































import Vue from 'vue'
import moment from 'moment'
import { dynamicDate } from '@/helpers/DateHelper'

export default Vue.extend({
	props: {
		article: {
			type: Object,
			required: true,
		},
		now: {
			type: moment,
			default: () => moment(),
		},
		alwaysFocused: {
			type: Boolean,
			default: false,
		},
		showFull: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			focused: false,
			newCommentText: '',
			comments: [] as any,
			commentOrder: 'trending',
			commentDeletionConfirmedFor: null as number|null,
			moreCommentsAvailable: false,
			showSharePopup: false,
			readMore: !!this.showFull,
			showAllCompanies: false,
			float: false,
			imageTooSmall: false,
		}
	},
	computed: {
		summary(): string {
			if (this.article.summary && this.article.summary.length > 350 && !this.readMore) {
				return `${this.article.summary.substring(0, 297)}...`
			}

			return this.article.summary
		},
		showReadMoreBtn(): boolean {
			return this.article.summary
				&& this.article.summary.length > 350
				&& !this.readMore
		},
		hideImagePreview(): boolean {
			return this.imageTooSmall && !this.focused && !this.alwaysFocused
		},
		showFullImage(): boolean {
			return this.article.image_url && (this.alwaysFocused || this.focused)
		},
	},
	watch: {
		focused(val) {
			this.checkImageBreakpoint()

			if (val === true) {
				this.loadComments()
				const { scrollTop } = document.documentElement
				document.documentElement.classList.add('disabled-scrolling')
				document.documentElement.style.top = `-${scrollTop}px`
			} else {
				const { top } = document.documentElement.style
				document.documentElement.classList.remove('disabled-scrolling')
				document.documentElement.style.top = '0'
				document.documentElement.scrollTop = -parseInt(top, 10)
			}
		},
	},
	mounted() {
		if (this.alwaysFocused) {
			this.loadComments()
		}

		if (this.article.image_url) {
			this.checkImageBreakpoint()
		}
	},
	methods: {
		calculateDateDifference(now: any, dateString : string) {
			return dynamicDate(now, dateString, this.$i18n.locale)
		},
		checkImageBreakpoint() {
			if (this.article.image_url) {
				const img = new Image()
				const breakpoint = (document.querySelector('.news-item')?.clientWidth || 800) / 1.5

				img.onload = () => {
					if (img.width < breakpoint) {
						this.float = true
					}

					if (img.width < 300) {
						this.imageTooSmall = true
					}
				}

				img.src = this.article.image_url
			}
		},
		likeArticle(article: any) {
			this.$axios.post(`/api/network/news/${article.id}/like`)
				.then((resp) => {
					if (resp.data.status === 'ok') {
						article.is_liked = true
						article.like_count += 1
					}
				})
		},
		removeLike(article: any) {
			this.$axios.delete(`/api/network/news/${article.id}/like`)
				.then((resp) => {
					if (resp.data.status === 'ok') {
						article.is_liked = false
						article.like_count -= 1
					}
				})
		},
		loadComments() {
			if (this.$auth.loggedIn) {
				this.$axios.get(`/api/network/news/${this.article.id}/comments`, {
					params: {
						order: this.commentOrder,
						limit: 10,
					},
				}).then((response) => {
					if (response.data.status === 'ok') {
						this.comments = response.data.comments
						this.moreCommentsAvailable = response.data.more_comments_available
					}
				})
			}
		},
		submitComment() {
			this.$axios.post(`/api/network/news/${this.article.id}/comment`, {
				text: this.newCommentText,
			}).then((response) => {
				if (response.data.status === 'ok') {
					this.newCommentText = ''

					if (!this.comments) {
						this.comments = []
					}

					this.comments.unshift(response.data.comment)
					// eslint-disable-next-line vue/no-mutating-props
					this.article.comment_count += 1
				} else {
					this.$nuxt.$emit('showToastMessage', {
						message: this.$t('error.unkown').toString(),
						duration: 3000,
					})
				}
			}).catch((error) => {
				console.log(error)
				this.$nuxt.$emit('showToastMessage', {
					message: this.$t('error.unkown').toString(),
					duration: 3000,
				})
			})
		},
		likeComment(comment: any) {
			this.$axios.post(`/api/network/comment/${comment.id}/like`, {}, {
				params: {
					type: 'news',
				},
			}).then((response) => {
				if (response.data.status === 'ok') {
					comment.is_liked = true
					comment.like_count += 1
				}
			})
		},
		removeCommentLike(comment: any) {
			this.$axios.delete(`/api/network/comment/${comment.id}/like`, {
				params: {
					type: 'news',
				},
			}).then((response) => {
				if (response.data.status === 'ok') {
					comment.is_liked = false
					comment.like_count -= 1
				}
			})
		},
		deleteComment(comment: any, index: any) {
			if (this.commentDeletionConfirmedFor === comment.id) {
				this.$axios.delete(`/api/network/comment/${comment.id}`, {
					params: {
						type: 'news',
					},
				}).then((response) => {
					if (response.data.status === 'ok') {
						this.comments.splice(index, 1)
						// eslint-disable-next-line vue/no-mutating-props
						this.article.comment_count -= 1
						this.commentDeletionConfirmedFor = null
					}
				})
			} else {
				this.commentDeletionConfirmedFor = comment.id

				setTimeout(() => {
					if (this.commentDeletionConfirmedFor === comment.id) {
						this.commentDeletionConfirmedFor = null
					}
				}, 5000)
			}
		},
	},
})
